import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Opinion 2-Up",
    description:
        "Opinion package with 2-column layout. This package requires content with bylines, it will render with a light blue background.",
    links: [
        {
            name: "Figma",
            url: "https://www.figma.com/design/gMELOCd5MiIqECTbVITX8y/Homepage?node-id=1559-7006&m=dev",
        },
    ],
};
